import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { Bookpage } from "@pcp/core/interfaces";
import { BookpageListDialogComponent, BookpageListDialogData } from "./bookpage-list-dialog/bookpage-list-dialog.component";
import { ToolbarActions } from "shared/classroom/toolbar/data-access";
import { take, tap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class BookpageDialogService {
    private dialogRef?: MatDialogRef<BookpageListDialogComponent>;

    constructor(private dialog: MatDialog, private store: Store) {}

    open(bookpages: Bookpage[], selectedBookpage: null | Bookpage = null) {
        const componentData: BookpageListDialogData = {
            bookpages,
            selectedBookpage,
        };
        this.dialogRef = this.dialog.open(BookpageListDialogComponent, {
            data: componentData,
            maxWidth: '90vw',
            maxHeight: '90vh',
            panelClass: [
                'dialog-custom-outer-paddings-small',
                'dialog-max-height-scrolling',
            ],
            autoFocus: false,
        });

        this.dialogRef
            .afterClosed()
            .pipe(
                take(1),
                tap((data) => {
                    const selectedBookpage: null | Bookpage =
                        data?.selectedBookpage || null;
                    if (selectedBookpage !== null) {
                        this.store.dispatch(
                            ToolbarActions.closeBookpageDialogConfirm({
                                selectedBookpage,
                            })
                        );
                    } else {
                        //turn off bookpage tool in case no page was selected from the dialog (e.g. dialog was closed by ESC keypress):
                        this.store.dispatch(
                            ToolbarActions.closeBookpageDialogCancel()
                        );
                    }
                })
            )
            .subscribe();
    }
}
